<!--
  我的收藏
-->
<style scoped>
  .content-main {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    min-height: 100vh;
  }

  /*中间消息面板*/
  .center-box {
    flex: 1;
    background: #fff;
    box-shadow: 0 7px 11px 0 rgba(231, 231, 231, 0.7);
    border-radius: 2px;
    margin-bottom: 50px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .content-layout-class {
    flex: 1;
  }

  /* 类型 */

  .top-title-type {
    display: flex;
    height: 60px;
    border-bottom: 1px solid rgba(204, 204, 204, .41);;
  }

  .top-title-type > .item {
    color: #666666;
    cursor: pointer;
    line-height: 60px;
    margin: 0 20px;
  }

  .top-title-type > .item.checked-type {
    border-bottom: 1px solid #000000;
    color: #000000;
  }

  .item {
    display: inline-block;
    font-size: 14px;
  }
</style>

<template>
  <div class="content-main">
    <WNav/>
    <Back/>
    <div class="center-box word">
      <div class="top-title-type" @click="typeChange">
        <div class="item"
             v-for="(item , index) in typeList"
             data-type="type"
             :data-index="index"
             :class="checkedTypeIndex === index ? 'checked-type' : ''"
        >{{item}}</div>
      </div>
      <div class="content-layout-class">
        <!--内容插槽-->
        <slot name="content-slot"/>
      </div>
      <!-- footer pagerHelper -->
      <slot name="pager-slot" />
      <slot name="model-slot"/>
    </div>
    <!--footer-->
    <FooterModle></FooterModle>
  </div>
</template>

<script>
  import WNav from "./WhiteNav";
  import FooterModle from "./Footer"
  import Back from './Back';

  export default {
    name: "collectionAll",
    components: {WNav, FooterModle, Back},
    props:{
      //顶部类型列表
      typeList:{
        type:Array,
        default:[]
      },
      //顶部类型改变时触发的事件
      typeChangeEvent:{
        type:Function,
        default:null
      }
    },
    data() {
      return {
        checkedTypeIndex: 0
      };
    },
    methods: {
      typeChange(e) {
        let index = Number(e.target.dataset['index']);
        if (isNaN(index)) return;
        if (this.checkedTypeIndex === index || index < 0 || index >= this.typeList.length) return;
        //初始化当前选择状态下的数据
        this.checkedTypeIndex = index;
        this.typeChangeEvent && this.typeChangeEvent(index) ;
        e.cancelBubble = true ;
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/assembly/SecondaryPageComponent.vue